import VerticalTabs from "common/ComponentSidebar/ComponentSideBar";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import {
  checkSubscriptions,
  // checkSubscriptionFeatureItem,
} from "Helpers/CheckSubscriptions";
import { useNavigate } from "react-router-dom";

interface tabProps {
  params: any;
  selectedIndex: number;
}
export default function CustomerTabs(props: tabProps) {
  const navigate = useNavigate();
  const handleChangeTabs = (tabId: number) => {
    if (tabId === 0) navigate(`/customer/${props.params?.id}`);
    else if (tabId === 1)
      navigate(`/customer/${props.params?.id}/update-password`);
    else if (tabId === 2) navigate(`/customer/${props.params?.id}/vehicles`);
    else if (tabId === 3) navigate(`/customer/${props.params?.id}/invoices`);
    else if (tabId === 4) navigate(`/customer/${props.params?.id}/payments`);
    else if (tabId === 5) navigate(`/customer/${props.params?.id}/reviews`);
  };
  const tabs = [
    { id: 0, title: `edit`, child: <></> },
    { id: 1, title: `updatePassword`, child: <></> },
    { id: 2, title: `vehicles`, child: <></> },
    { id: 3, title: `invoices`, child: <></> },
    { id: 4, title: `payments`, child: <></> },
    { id: 5, title: `reviews`, child: <></> },
  ];
  const disableTabs = tabs
    .map((tab) => tab.id)
    .filter((tabId) => {
      switch (tabId) {
        case 0:
          return !checkPrivileges("ROLE_CUSTOMER_UPDATE");
        case 1:
          return !checkPrivileges("ROLE_CHANGE_PASSWORD");
        case 2:
          return !checkPrivileges("ROLE_VEHICLE_VIEW");
        case 3:
          return !checkPrivileges("ROLE_INVOICE_VIEW");
        case 4:
          return (
            !checkPrivileges("ROLE_PAYMENT_VIEW") ||
            !checkSubscriptions("PAYMENT")
          );
        case 5:
          return false;
        default:
          return false;
      }
    });

  return (
    <>
      <VerticalTabs
        tabs={tabs}
        selectedIndex={props.selectedIndex}
        handleChangeTabs={handleChangeTabs}
        disableTabNo={disableTabs}
      />
    </>
  );
}
